(function () {
  'use strict';

  // Reads the accent bar's real rendered color (scheme 2, whatever that
  // resolves to for this client/theme) and exposes it as a CSS variable
  // on the card, so info-card.css can use it for a soft background
  // wash/border tint instead of a hardcoded color. Same approach as
  // pickup-availability-cards.js, kept independent since this card has
  // no dependency on Frengee's app or markup.
  function setAccentColorVar(card) {
    if (card.style.getPropertyValue('--frengee-accent-rgb')) return;
    var accent = card.querySelector('.info-card__accent');
    if (!accent) return;
    var bg = getComputedStyle(accent).backgroundColor;
    var match = bg && bg.match(/\d+(\.\d+)?/g);
    if (!match || match.length < 3) return;
    card.style.setProperty('--frengee-accent-rgb', match[0] + ', ' + match[1] + ', ' + match[2]);
  }

  function processAll() {
    document.querySelectorAll('.info-card').forEach(setAccentColorVar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }
})();
